import { AttendanceFeatures } from './AttendanceFeatures';
import { ActiveMessageFeatures } from 'modules/shared/featureToggle/ActiveMessageFeatures';
import { BuilderFeatures } from 'modules/application/detail/portal-submodule-builder/templates/builder/BuilderFeatures';
import { ReportFeatures } from './report/ReportFeatures';
import { AttendanceConstants } from './AttendanceConstants';
import { BlipCopilotFeatures } from 'modules/shared/featureToggle/BlipCopilot';
export class AttendanceMenuController {
    static $inject = ['SegmentService', 'application', 'ActiveMessageDeskSharedService', 'TranslateService', 'DeskConfigurationService', 'CopilotService'];
    constructor(SegmentService, application, ActiveMessageDeskSharedService, TranslateService, DeskConfigurationService, CopilotService) {
        'ngInject';
        this.SegmentService = SegmentService;
        this.application = application;
        this.ActiveMessageDeskSharedService = ActiveMessageDeskSharedService;
        this.TranslateService = TranslateService;
        this.DeskConfigurationService = DeskConfigurationService;
        this.CopilotService = CopilotService;
        this.isHideRulesAttendants = false;
        this.isActiveMessagesPermissionEnabled = false;
        this.isWhatsAppChannelConnected = false;
        this.isTextRewriteForReportEnabled = false;
        this.isSalesDashboardEnabled = false;
        this.isSurveyDashboardEnabled = false;
        this.isLeadScoreEnabled = false;
        this.isCallsDashboardEnabled = false;
        this.isTenantBlipCopilotEnabled = false;
        this.isSLAPolicyMfeEnabled = false;
        this.isConfigurationsApplicationsDomainUsageGetEnabled = false;
        this.isMetadataManagementEnabled = false;
        this.isBlipCopilotMFEEnabled = false;
        this.isDeskQAEnabled = false;
        this.getMonitoringTranslation = (label) => {
            const baseLabel = 'attendance.menu.monitoring';
            return `${baseLabel}.v2.${label}`;
        };
    }
    async $onInit() {
        await this.checkFeatures();
        this.isWhatsAppChannelConnected = await this.ActiveMessageDeskSharedService.getIsWhatsAppConnected();
    }
    async checkFeatures() {
        this.isConfigurationsApplicationsDomainUsageGetEnabled = await AttendanceFeatures.isUseConfigurationsDomainOnAttendanceOperationsGetEnabled();
        const [isHideRulesAttendants, isActiveMessagesPermissionEnabled, isActiveMessageSettingsValidationEnabled, isRedirectOutOfAttendanceHourEnabled, isActiveMessageSettingsMfeEnabled, isAttendantMfeEnabled, isQueueManagementMfeEnabled, isReportMfeEnabled, isMonitoringMfeEnabled, isChannelsMfeEnabled, isRepliesMfeEnabled, isTextRewriteForReportEnabled, isSalesDashboardEnabled, isSurveyDashboardEnabled, isLeadScoreEnabled, isCallsDashboardEnabled, isSLAPolicyMfeEnabled, isTenantBlipCopilotEnabled, isMetadataManagementEnabled, isBlipCopilotMFEEnabled, isDeskQAEnabled,] = await Promise.all([
            AttendanceFeatures.isHideRulesAttendantsEnabled(),
            ActiveMessageFeatures.isActiveMessagesPermissionEnabled(),
            ActiveMessageFeatures.isActiveMessageSettingsValidationEnabled(),
            BuilderFeatures.isRedirectOutOfAttendanceHourEnabled(),
            AttendanceFeatures.isActiveMessageSettingsMfeEnabled(),
            AttendanceFeatures.isAttendantMfeEnabled(),
            AttendanceFeatures.isQueueManagementMfeEnabled(),
            AttendanceFeatures.isReportMfeEnabled(),
            AttendanceFeatures.isMonitoringMfeEnabled(),
            AttendanceFeatures.isChannelsMfeEnabled(),
            AttendanceFeatures.isRepliesMfeEnabled(),
            ReportFeatures.isTextRewriteEnabled(),
            AttendanceFeatures.isSalesDashboardEnabled(),
            AttendanceFeatures.isSurveyDashboardEnabled(),
            AttendanceFeatures.isLeadScoreFeature(),
            AttendanceFeatures.isCallsDashboardEnabled(),
            AttendanceFeatures.isSLAPolicyMfeEnabled(),
            this.CopilotService.getCopilotTenantEnablementStatus().then(response => response.resource?.isAvailable || false),
            AttendanceFeatures.isMetadataManagementEnabled(),
            BlipCopilotFeatures.isBlipCopilotMFEEnabled(),
            AttendanceFeatures.isDeskQAEnabled(),
        ]);
        let historyScreen = localStorage.getItem(AttendanceConstants.HISTORY_SCREEN);
        const phasedHistoryMfeFT = await AttendanceFeatures.phasedHistoryMfeFT();
        if (!historyScreen && phasedHistoryMfeFT === AttendanceConstants.BOTH_SCREENS) {
            historyScreen = AttendanceConstants.MFE_SCREEN;
            localStorage.setItem(AttendanceConstants.HISTORY_SCREEN, historyScreen);
        }
        this.isHistoryMfeEnabled = phasedHistoryMfeFT !== AttendanceConstants.PORTAL_ONLY && historyScreen === AttendanceConstants.MFE_SCREEN;
        this.isHideRulesAttendants = isHideRulesAttendants;
        this.isActiveMessagesPermissionEnabled = isActiveMessagesPermissionEnabled;
        this.isActiveMessageSettingsValidationEnabled = isActiveMessageSettingsValidationEnabled;
        this.isRedirectOutOfAttendanceHourEnabled = isRedirectOutOfAttendanceHourEnabled;
        this.isActiveMessageSettingsMfeEnabled = isActiveMessageSettingsMfeEnabled;
        this.isAttendantMfeEnabled = isAttendantMfeEnabled;
        this.isQueueManagementMfeEnabled = isQueueManagementMfeEnabled;
        this.isReportMfeEnabled = isReportMfeEnabled;
        this.isMonitoringMfeEnabled = isMonitoringMfeEnabled;
        this.isChannelsMfeEnabled = isChannelsMfeEnabled;
        this.isRepliesMfeEnabled = isRepliesMfeEnabled;
        this.isTextRewriteForReportEnabled = isTextRewriteForReportEnabled;
        this.isSalesDashboardEnabled = isSalesDashboardEnabled;
        this.isSurveyDashboardEnabled = isSurveyDashboardEnabled && this.TranslateService.getCurrentLanguage() === 'pt';
        this.isLeadScoreEnabled = isLeadScoreEnabled;
        this.isCallsDashboardEnabled = isCallsDashboardEnabled;
        this.isSLAPolicyMfeEnabled = isSLAPolicyMfeEnabled;
        this.isTenantBlipCopilotEnabled = isTenantBlipCopilotEnabled;
        this.isMetadataManagementEnabled = isMetadataManagementEnabled;
        this.isBlipCopilotMFEEnabled = isBlipCopilotMFEEnabled;
        this.isDeskQAEnabled = isDeskQAEnabled;
    }
    trackOpenTab(trackString) {
        this.SegmentService.createApplicationTrack({
            trackEvent: trackString,
            application: this.application,
        });
    }
}
AttendanceMenuController.$inject = ['SegmentService', 'application', 'ActiveMessageDeskSharedService', 'TranslateService', 'DeskConfigurationService', 'CopilotService'];
